module.exports = function(app) {
    app.directive('spaPlanCard', function() {

        return {
            restrict: 'A',
            template: require('directives/common/spaPlanCard.html'),
            scope:{
                plan: '=spaPlanCard',
                editMode: '=spaPlanCardMode',
                validationSuffix: '@',
                accountType:'=spaPlanAccountType'
                 },

            controller: ['$scope', 'coremetrics','$state', '$filter',
                function($scope, coremetrics, $state, $filter) {
                    $scope.endDateMax = new Date($scope.plan.contractEndDate.getFullYear(), $scope.plan.contractEndDate.getMonth(), $scope.plan.contractEndDate.getDate() +1);
                    $scope.EmployeeAnnualContribution = "Employee Annual Contribution";
                    $scope.TotalAnnualContribution = "Total Annual Contribution";
                    $scope.isEmployeeAnnualContributionRequired = true;
                    $scope.isTotalAnnualContributionRequired = true;
                    var FSA=["DCARE","FSA","MED","LMED","LFSA","DCA"];
                    var Park_Tran=["TRANS","PARK","PKG","TNG"];
                    var HRA = ["HRA","HRAW","RRA","HRAI"];
                    var accountType = ($scope.accountType).toUpperCase();
                    if(FSA.indexOf(accountType)>-1){
                        $scope.EmployeeAnnualContribution="Employee Annual Election";
                        $scope.TotalAnnualContribution="Contribution Year to Date";
                    }
                    else if(Park_Tran.indexOf(accountType)>-1){
                        $scope.TotalAnnualContribution="Contribution Year to Date";
                        $scope.isEmployeeAnnualContributionRequired = false;
                    }
                    else if(HRA.indexOf(accountType) > -1){
                        $scope.EmployeeAnnualContribution="Annual Election";
                        $scope.isTotalAnnualContributionRequired = false;
                    }
                    

            }
            ]
        };
        
    });

    
};
